/* Prime Review お気に入り 共通スクリプト
   mxpr-card-product-favorite-v2.liquid（検証用）が使用。
   オリジナル snippet がカードごとにインライン出力していた
   関数定義・<style>・product JSON を1ファイルに集約（HTML肥大と多重スタイル再計算の解消）。
   ※ increment カウンターは render を跨いで共有されないため（検証済み：カード数ぶん重複出力される）、
     「ページ内1回だけ」はこの外部アセット＋実行ガードでしか実現できない。
   カード側は window.mxprFavQueue に登録情報を push するだけ。
   グローバルAPI（window.handleClick / updateFavButton 等）は旧実装と同名・同挙動。 */
(function () {
  if (window.__mxprFavSetup) return;
  window.__mxprFavSetup = true;

  var cfg = { customer: false, allowGuest: false, pos: 'right-top' };

  /* 旧スニペットの per-card <style> を共通セレクタで1回だけ注入 */
  var styled = false;
  function ensureStyles() {
    if (styled) return;
    styled = true;
    var posMap = {
      'left-top': { btn: 'top:0;left:0;', list: 'top:20px;left:5px;' },
      'left-bottom': { btn: 'bottom:0;left:0;', list: 'bottom:20px;left:5px;' },
      'right-bottom': { btn: 'bottom:0;right:0;', list: 'bottom:20px;right:5px;' },
      'right-top': { btn: 'top:0;right:0;', list: 'top:20px;right:5px;' }
    };
    var pos = posMap[cfg.pos] || posMap['right-top'];
    var btnSel = 'div[class^="prime-review-favorites-product-"]';
    var listSel = 'ul[class*="prime-review-favorites-product-"][class$="-variants"]';
    var css =
      btnSel + '{position:absolute;' + pos.btn + 'padding:10px;width:50px;height:50px;z-index:2;cursor:pointer}' +
      'g[class*="prime-review-favorites-heart-"][class*="-enable"]{fill:#00a9e0}' +
      'g[class*="prime-review-favorites-heart-"][class*="-disable"]{fill:#bfbfbf}' +
      listSel + '{display:none;position:absolute;' + pos.list + 'z-index:3;background-color:#fff;padding-left:0;list-style-type:none;border-radius:3px;border:1px solid #ccc;max-height:217px;width:200px;--clr-Theme:#00ABEA;overflow-x:hidden;overflow-y:scroll;scroll-snap-type:x mandatory;scrollbar-color:var(--clr-Theme) transparent;scrollbar-width:thin}' +
      listSel + '::-webkit-scrollbar{width:8px}' +
      listSel + '::-webkit-scrollbar-track{background:transparent}' +
      listSel + '::-webkit-scrollbar-thumb{background:var(--clr-Theme);border-radius:4px}' +
      listSel + '::-webkit-scrollbar-thumb:hover{background:var(--clr-Theme)}' +
      listSel + ' li{position:relative;z-index:3;padding:5px 5px 5px 20px;min-width:100px;border-top:1px solid #ddd;text-align:left;color:#333}' +
      listSel + ' li:first-child{border-top:0}' +
      listSel + ' li.exist:after,' + listSel + ' li.exist:hover:after{content:"";display:block;position:absolute;top:13px;left:.5em;width:.8em;height:.4em;border-left:2px solid #9c9c9c;border-bottom:2px solid #9c9c9c;transform:rotate(-45deg)}' +
      listSel + ' li:hover:after{content:"";display:block;position:absolute;top:13px;left:.5em;width:.8em;height:.4em;border-left:2px solid #fff;border-bottom:2px solid #fff;transform:rotate(-45deg)}' +
      listSel + ' .exist{color:#00a9e0}';
    var styleEl = document.createElement('style');
    styleEl.id = 'mxpr-favorite-style';
    styleEl.textContent = css;
    document.head.appendChild(styleEl);
  }

  window.handleClick = function (productHash) {
    var variants = document.querySelector('.prime-review-favorites-product-' + productHash + '-variants');
    if (!variants) return;
    if (variants.dataset.hasOnlyDefaultVariant == 'true' || variants.children.length <= 1) {
      if (variants.firstElementChild) {
        window.toggleFavorite(variants.firstElementChild);
      }
    } else {
      if (variants.style.display == 'block') {
        variants.style.display = 'none';
      } else {
        variants.style.display = 'block';
      }
    }
  };

  window.refreshHeart = function (productHash) {
    var list = document.querySelectorAll('.prime-review-favorites-product-' + productHash + '-variants *');
    var exist = false;
    var heart = document.querySelector('.prime-review-favorites-heart-' + productHash);
    var border = document.querySelector('.prime-review-favorites-heart-border-' + productHash);
    if (!heart || !border) return;
    for (var i = 0; i < list.length; i++) {
      if (list[i].classList.contains('exist')) {
        exist = true;
      }
    }
    if (exist) {
      heart.classList.remove('prime-review-favorites-heart-' + productHash + '-disable');
      heart.classList.add('prime-review-favorites-heart-' + productHash + '-enable');
      border.classList.remove('prime-review-favorites-heart-border-' + productHash + '-disable');
      border.classList.add('prime-review-favorites-heart-border-' + productHash + '-enable');
    } else {
      heart.classList.remove('prime-review-favorites-heart-' + productHash + '-enable');
      heart.classList.add('prime-review-favorites-heart-' + productHash + '-disable');
      border.classList.remove('prime-review-favorites-heart-border-' + productHash + '-enable');
      border.classList.add('prime-review-favorites-heart-border-' + productHash + '-disable');
    }
    if (window.updateFavButton) window.updateFavButton(productHash);
  };

  window.getVariantInfo = function (handle, variantId) {
    var product = window.mxProductInfoCollection[handle];
    if (!product || !product.variants || product.variants.length === 0) return null;
    var variant;
    if (variantId) {
      variant = product.variants.find(function (v) { return v.id == variantId; });
    }
    if (!variant) {
      variant = product.variants[0];
    }
    if (!variant) return null;
    var variantInfo = {
      imageUrl: product.featured_image || null,
      url: '/products/' + product.handle,
      title: product.title,
      handle: product.handle,
      variantTitle: variant.public_title,
      variantId: variant.id,
      price: variant.price,
      tags: product.tags
    };
    return variantInfo;
  };

  window.changeFloatCount = function (add, variantId) {
    var floatCountDiv = document.getElementById('prime-review-favorites-count');
    if (floatCountDiv) {
      var count = Number(floatCountDiv.innerText) || 0;
      count = count + add;
      floatCountDiv.innerText = String(count);
      if (count <= 0) {
        floatCountDiv.style.display = 'none';
      } else {
        floatCountDiv.style.display = 'block';
      }
    }
    var variants = document.querySelectorAll('li.prime-review-variant-' + variantId);
    for (var i = 0; i < variants.length; i++) {
      if (add == 1) {
        variants[i].classList.add('exist');
      } else {
        variants[i].classList.remove('exist');
      }
      window.refreshHeart(variants[i].dataset.productHash);
    }
    if (window.showFavoriteToast) {
      window.showFavoriteToast(add == 1 ? 'お気に入りに登録しました' : 'お気に入りを解除しました');
    }
  };

  window.submitFavorite = async function (url, handle, variant) {
    var fetchOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        handle: handle,
        variant: variant
      })
    };
    await fetch(url, fetchOptions);
  };

  window.toggleFavorite = function (source) {
    if (!source) return;
    var variantId = source.dataset.variantId;
    var handle = source.dataset.handle;
    var productHash = source.dataset.productHash;
    if (!variantId || !handle || !productHash) return;
    if (cfg.customer) {
      if (source.classList.contains('exist')) {
        window.submitFavorite('/tools/prime-review/api/removeFavorite', handle, variantId);
        window.changeFloatCount(-1, variantId);
      } else {
        window.submitFavorite('/tools/prime-review/api/addFavorite', handle, variantId);
        window.changeFloatCount(1, variantId);
      }
    } else if (cfg.allowGuest) {
      var favorites = JSON.parse(localStorage.getItem('mxpr-favorites')) || [];
      if (favorites.some(function (favorite) { return favorite.variantId == variantId; })) {
        var index = favorites.findIndex(function (favorite) { return favorite.variantId == variantId; });
        if (index >= 0) {
          favorites.splice(index, 1);
          localStorage.setItem('mxpr-favorites', JSON.stringify(favorites));
        }
        window.changeFloatCount(-1, variantId);
      } else {
        var variantInfo = window.getVariantInfo(handle, variantId);
        if (variantInfo) {
          favorites.unshift(variantInfo);
          localStorage.setItem('mxpr-favorites', JSON.stringify(favorites));
          window.changeFloatCount(1, variantId);
        }
      }
    } else {
      if (confirm('この機能を利用するにはログインが必要です。')) {
        location.href = '/account/login?checkout_url=' + location.pathname;
      }
    }
    if (navigator.maxTouchPoints > 0 && productHash) {
      var variants = document.querySelector('.prime-review-favorites-product-' + productHash + '-variants');
      if (variants) {
        variants.style.display = 'none';
      }
    }
  };

  window.checkCookies = function (productHash, handle) {
    var favorites = JSON.parse(localStorage.getItem('mxpr-favorites')) || [];
    if (favorites.some(function (favorite) { return favorite.handle == handle; })) {
      var heart = document.querySelector('.prime-review-favorites-heart-' + productHash);
      var border = document.querySelector('.prime-review-favorites-heart-border-' + productHash);
      if (heart && border) {
        heart.classList.remove('prime-review-favorites-heart-' + productHash + '-disable');
        heart.classList.add('prime-review-favorites-heart-' + productHash + '-enable');
        border.classList.remove('prime-review-favorites-heart-border-' + productHash + '-disable');
        border.classList.add('prime-review-favorites-heart-border-' + productHash + '-enable');
      }
    }
    var list = document.querySelectorAll('.prime-review-favorites-product-' + productHash + '-variants *');
    for (var i = 0; i < list.length; i++) {
      var child = list[i];
      if (favorites.some(function (favorite) { return child.dataset.variantId == String(favorite.variantId); })) {
        child.classList.add('exist');
      }
    }
  };

  /* 自前のお気に入りボタン（pd26-feat__card-fav）の見た目を登録状態で切替 */
  window.updateFavButton = function (productHash) {
    var faved = document.querySelectorAll('.prime-review-favorites-product-' + productHash + '-variants li.exist').length > 0;
    document.querySelectorAll('[data-fav-hash="' + productHash + '"]').forEach(function (btn) {
      btn.classList.toggle('is-faved', faved);
      btn.setAttribute('aria-pressed', faved ? 'true' : 'false');
      var label = btn.querySelector('.pd26-feat__card-fav-label');
      if (label) label.textContent = faved ? '登録済み' : 'お気に入り登録';
    });
  };

  /* お気に入りの登録/解除を知らせるトースト通知（画面上中央・約2秒で自動で消える） */
  window.showFavoriteToast = function (message) {
    var toast = document.getElementById('mxpr-fav-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'mxpr-fav-toast';
      toast.setAttribute('role', 'status');
      toast.style.cssText = 'position:fixed;left:50%;top:24px;bottom:auto;transform:translateX(-50%) translateY(-10px);background:#000f16;color:#fff;padding:12px 20px;border-radius:999px;font-size:14px;font-weight:700;line-height:1.4;box-shadow:0 6px 20px rgba(0,0,0,.25);z-index:9999;opacity:0;visibility:hidden;transition:opacity .25s ease, transform .25s ease, visibility .25s;pointer-events:none;max-width:90vw;text-align:center;white-space:nowrap;';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    requestAnimationFrame(function () {
      toast.style.opacity = '1';
      toast.style.visibility = 'visible';
      toast.style.transform = 'translateX(-50%) translateY(0)';
    });
    clearTimeout(window.__mxprFavToastTimer);
    window.__mxprFavToastTimer = setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.visibility = 'hidden';
      toast.style.transform = 'translateX(-50%) translateY(-10px)';
    }, 2000);
  };

  /* 開いているプルダウンの外側をクリックしたら閉じる（リスト自身・対応ボタンのクリックは除外） */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('ul[class*="prime-review-favorites-product-"]').forEach(function (list) {
      if (list.style.display !== 'block') return;
      if (list.contains(e.target)) return;
      var cls = Array.from(list.classList).find(function (c) {
        return c.indexOf('prime-review-favorites-product-') === 0 && c.endsWith('-variants');
      });
      if (!cls) return;
      var hash = cls.replace(/^prime-review-favorites-product-/, '').replace(/-variants$/, '');
      if (e.target.closest('.prime-review-favorites-product-' + hash)) return;
      if (e.target.closest('[onclick*="' + hash + '"]')) return;
      list.style.display = 'none';
    });
  });

  window.primeReviewInitialized = true;

  if (!window.mxProductInfoCollection) {
    window.mxProductInfoCollection = {};
  }

  /* カードごとの登録（旧 per-card スクリプトの load ハンドラ相当） */
  function register(item) {
    if (!item || !item.hash) return;
    cfg.customer = !!item.customer;
    cfg.allowGuest = !!item.allowGuest;
    if (item.pos) cfg.pos = item.pos;
    ensureStyles();
    if (item.product && item.handle) {
      window.mxProductInfoCollection[item.handle] = item.product;
    }
    document.querySelectorAll('.prime-review-favorites-product-' + item.hash).forEach(function (btn) {
      if (btn.__mxprBound) return;
      btn.__mxprBound = true;
      btn.addEventListener('click', function () { window.handleClick(item.hash); }, true);
    });
    document.querySelectorAll('.prime-review-favorites-product-' + item.hash + '-variants').forEach(function (variants) {
      if (variants.__mxprBound) return;
      variants.__mxprBound = true;
      variants.addEventListener('mouseleave', function (e) { e.target.style.display = 'none'; });
    });
    if (!cfg.customer && cfg.allowGuest) window.checkCookies(item.hash, item.handle);
    if (window.updateFavButton) window.updateFavButton(item.hash);
  }

  /* パース中に積まれたキューを処理し、以降の push は即時登録に差し替え */
  var pending = window.mxprFavQueue;
  window.mxprFavQueue = { push: register };
  if (pending && pending.length) pending.forEach(register);
})();
